export const BANNER_CONSTS = {
    GET_BANNERS: "GET_BANNERS",
    CREATE_BANNER: "CREATE_BANNER",
    GET_BANNER_BY_ID: "GET_BANNER_BY_ID",
    UPDATE_BANNERS_POSITIONS: "UPDATE_BANNERS_POSITIONS",
    UPDATE_BANNER_BY_ID: "UPDATE_BANNER_BY_ID",
    DELETE_BANNER_BY_ID: "DELETE_BANNER_BY_ID",
    CLEAR_BANNER_DATA: "CLEAR_BANNER_DATA",
};
